import React, { useMemo } from "react";
import { Spinner } from "reactstrap";
import { VsiBubbleFavs } from "../styled/App.styled";
import { useVsiAppContext } from "../stores/VsiApp";
import VerticalBarChart from "../components/VerticalBarChart";

import "react-datepicker/dist/react-datepicker.css";
import { useDataWithRoute } from "../utils/hooks";

const titles = ["Used Growth (GB)", "IOPs Growth"];
export default function EnterprisePerformance({ params }) {
  const { client: { clientId }, getPeriodId } = useVsiAppContext();
  const periodId = getPeriodId("STORAGE");

  const route = useMemo(() => {
    let newRoute = `/api/v6/report/enterprise_one_month_performance_proc?client_id=${clientId}&period_id=${periodId}`;
    if (params.length > 1) {
      const begPid = params?.find?.(p => p.param === "start_period")?.value;
      const endPid = params?.find?.(p => p.param === "end_period")?.value ?? periodId;
      newRoute = `/api/v6/report/enterprise_monthly_performance_proc?client_id=${clientId}&beginning_period_id=${begPid}&end_period_id=${endPid}`;
    }
    return newRoute;
  }, [clientId, periodId, params, periodId]);

  const [{ recordset: data }, { isLoading }] = useDataWithRoute(route);

  const { devices, chartSeries, maxMin } = useMemo(() => {

    const deviceData = data.map(device => device.device_type_code);
    const uniqueDevices = deviceData.filter((device, index) => deviceData.indexOf(device) === index);
    let newData = [];

    for (let i = 0; i < uniqueDevices.length; i++) {
      let iopsGrowth = 0;
      let totalUsedGrowth = 0;
      for (let y = 0; y < data.length; y++) {
        if (uniqueDevices[i] === data[y].device_type_code) {
          iopsGrowth = iopsGrowth + data[y].iops_growth;
          totalUsedGrowth = totalUsedGrowth + data[y].total_used_growth;
        }
      }
      newData.push({
        device: uniqueDevices[i],
        iops_growth: parseInt(Math.round(iopsGrowth * 100) / 100),
        total_used_growth: parseInt(Math.round(totalUsedGrowth * 100) / 100)
      });
    }

    const dataArray = [];

    // Loop to get the info needed for graph
    for (let i = 0; i < newData.length; i++) {
      let graphInfo = (({ iops_growth, total_used_growth }) => ({
        total_used_growth,
        iops_growth
      }))(newData[i]);
      dataArray.push(graphInfo);
    }

    const finalArray = []; // For reorganized objects

    for (let y = 0; y < titles.length; y++) {
      // Array of objects > array of arrays
      const smallerArrays = [];
      for (let i = 0; i < dataArray.length; i++) {
        const values = Object.values(dataArray[i]);

        smallerArrays.push(values);
      }

      // Return just values by category
      const removedKeys = [];
      for (let i = 0; i < smallerArrays.length; i++) {
        const newArray = smallerArrays[i].map(data => {
          return data;
        });
        removedKeys.push(newArray[y]);
      }
      finalArray.push(removedKeys);
    }

    // For column chart axes
    let axis2Max;
    let axis2Min;

    if (finalArray[1].length === 1 && finalArray[1][0] > 0) {
      axis2Min = 0;
      axis2Max = finalArray[1][0];
    } else if (finalArray[1].length === 1 && finalArray[1][0] < 0) {
      axis2Max = 0;
      axis2Min = finalArray[1][0];
    } else {
      axis2Max = Math.max.apply(Math, finalArray[1]);
      axis2Min = Math.min.apply(Math, finalArray[1]);
    }
    let axis1Min;
    let axis1Max;

    if (finalArray[0].length === 1 && finalArray[0][0] > 0) {
      axis1Min = 0;
      axis1Max = finalArray[0][0];
    } else if (finalArray[0].length === 1 && finalArray[0][0] < 0) {
      axis1Max = 0;
      axis1Min = finalArray[0][0];
    } else {
      axis1Max = Math.max.apply(Math, finalArray[0]);
      axis1Min = Math.min.apply(Math, finalArray[0]);
    }

    const chartInfo = [];
    for (let i = 0; i < titles.length; i++) {
      chartInfo.push({
        name: titles[i],
        data: finalArray[i],
        yAxis: i
      });
    }

    return {
      devices: uniqueDevices,
      chartSeries: chartInfo,
      maxMin: {
        axis2Max: axis2Max || null,
        axis2Min: axis2Min || null,
        axis1Max: axis1Max || null,
        axis1Min: axis1Min || null
      }
    };
  }, [data]);

  console.log(chartSeries, devices, data)

  return isLoading ? (
    <Spinner color={"primary"} />
  ) : (
    <VsiBubbleFavs>
      <VerticalBarChart
        categories={devices}
        height={420}
        series={chartSeries}
        includeLegend={true}
        changeAxisTitle={true}
        axisMaxMin={maxMin}
        xTitle={"Device Type Code"}
        yTitle1={"GiB"}
        yTitle2={"IOPs"}
      />
    </VsiBubbleFavs>
  );
}
